export const useConfirmArchiveModal = (ctx) => {
    const getConfirmArchiveModalObject = (type, name) => {
        return {
            type: 'confirm',
            title: ctx.root.$t('confirm-archive-modal.modal-title', {
                type: ctx.root.$t(`confirm-archive-modal.${type}`),
            }),
            description: ctx.root.$t('confirm-archive-modal.modal-description', {
                name,
                type: ctx.root.$t(`confirm-archive-modal.${type}`),
            }),
            btnText: ctx.root.$t('confirm-archive-modal.modal-btn'),
        };
    };
    return { getConfirmArchiveModalObject };
};
